import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Navigate, Routes } from "react-router-dom";

import "assets/css/bootstrap.min.css";
import "assets/scss/paper-kit.scss";
import "assets/demo/demo.css";

import ScrollToTop from "components/ScrollToTop";
import ScrollToTopButton from "components/ScrollToTopButton";
import EventAnnouncementPopup from "components/EventAnnouncementPopup";
import { LoaderProvider } from "./contexts/loaderContext/loaderContext";
import { ToastProvider } from "contexts/toastContext/ToastContext";

const LandingPage = lazy(() => import("views/LandingPage.js"));
const AboutUs = lazy(() => import("views/AboutUs"));
const PublicSpeaking = lazy(() => import("views/PublicSpeaking"));
const ContactUs = lazy(() => import("views/ContactForm"));
const JciToyp = lazy(() => import("views/AboutUsSections/JciToyp"));
const YouthOwnedBrand = lazy(() => import("views/AboutUsSections/YouthOwnedBrand"));
const PublicSpeakingChampionships = lazy(() =>
  import("views/AboutUsSections/PublicSpeakingChampionships")
);
const BookNow = lazy(() => import("views/BookNow"));
const PrivacyPolicy = lazy(() => import("views/PrivacyPolicy"));
const TigerbrandsPartnership = lazy(() =>
  import("views/Partnerships/TigerbrandsPartnership")
);
const BrandsSaPartnership = lazy(() =>
  import("views/Partnerships/BrandsSaPartnership")
);
const TermsAndConditions = lazy(() => import("views/TermsAndConditions"));
const VoiceOver = lazy(() => import("views/VoiceOver"));
const Alumni = lazy(() => import("views/Alumni"));
const Schools = lazy(() => import("views/Schools"));
const ExecutiveCoaching = lazy(() => import("views/ExecutiveCoaching"));
const OneOnOneCoaching = lazy(() => import("views/OneOnOneCoaching"));
const CorporateTraining = lazy(() => import("views/CorporateTraining"));
const GroupMasterclasses = lazy(() => import("views/GroupMasterclasses"));
const EditGroup = lazy(() => import("views/AdminViews/EditGroup"));
const SendCerts = lazy(() => import("views/AdminViews/SendCert"));
const PaymentSuccessPage = lazy(() => import("views/Payment Redirects/Success"));
const PaymentErrorPage = lazy(() => import("views/Payment Redirects/Error"));
const CancelPage = lazy(() => import("views/Payment Redirects/Cancel"));
const OurTeamPage = lazy(() => import("views/Team"));

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <ToastProvider>
      <LoaderProvider>
        <ScrollToTop />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/home" element={<LandingPage />} />
            <Route path="/book-now" element={<BookNow />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/jci-toyp" element={<JciToyp />} />
            <Route path="/youth-owned-brands" element={<YouthOwnedBrand />} />
            <Route
              path="/2022-up-public-speaking-championships/"
              element={<PublicSpeakingChampionships />}
            />
            <Route path="/public-speaking" element={<PublicSpeaking />} />
            <Route path="/schools" element={<Schools />} />
            <Route path="/executive-coaching" element={<ExecutiveCoaching />} />
            <Route path="/one-on-one-coaching" element={<OneOnOneCoaching />} />
            <Route path="/corporate-training" element={<CorporateTraining />} />
            <Route path="/group-masterclasses" element={<GroupMasterclasses />} />
            <Route path="/voice-over" element={<VoiceOver />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/Tiger-Brands" element={<TigerbrandsPartnership />} />
            <Route
              path="/Brands-Southafrica"
              element={<BrandsSaPartnership />}
            />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="/alumni" element={<Alumni />} />
            <Route path="/edit-group/:groupId" element={<EditGroup />} />
            <Route
              path="/send-certificates/:groupId"
              element={<SendCerts />}
            />
            <Route path="/Success" element={<PaymentSuccessPage />} />
            <Route path="/Error" element={<PaymentErrorPage />} />
            <Route path="/Cancel" element={<CancelPage />} />
            <Route path="/our-team" element={<OurTeamPage />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </Suspense>
        <EventAnnouncementPopup />
        <ScrollToTopButton />
      </LoaderProvider>
    </ToastProvider>
  </BrowserRouter>
);
